import React, {useRef, useState} from 'react';
import * as Icons from 'react-feather';
import {useClickDetecter} from 'lib/helpers'
import {AUTH_REST, axiosInstance, handleErrors, removeToken, useAuth} from 'store/auth'
import {useNavigate} from "react-router-dom";
import Modal from "../Modal";
import {toast} from "react-toastify";
import {Field, Form, Formik} from "formik";
import {Loading, TextField} from "components/form";
import {minLength, required, validationWrapper} from "lib/formValidations";

export default function Account() {
   const [showMenu, setShowMenu] = useState(false)
   const [showProfile, setShowProfile] = useState(false)
   const [showPassword, setShowPassword] = useState(false)
   const wrapperRef = useRef(null);
   const auth = useAuth();
   let navigate = useNavigate();

   useClickDetecter(wrapperRef, (flag) => {
      setShowMenu(flag);
   });
   const resetPassword = () => {
      setShowMenu(false);
      setShowPassword(true);
   }
   const logout = async () => {
      await auth.dispatch(auth.logout());
      navigate(`/auth/login`);
   }
   const changeSideBar = () => {
      auth.dispatch(auth.toggleSideBar())
      localStorage.setItem("sidebar", !auth.sidebar)
   }
   return (<>
      <div className="intro-x dropdown w-8 h-8" ref={wrapperRef}>
         <button type="button" onClick={() => setShowMenu(!showMenu)}
              className="dropdown-toggle w-8 h-8 rounded-full overflow-hidden shadow-lg image-fit zoom-in scale-110"
              aria-label="منوی حساب کاربری" aria-expanded={showMenu}>
            <img alt="vfilms" src="/images/account.jpg"/>
         </button>
         <div className={`dropdown-menu w-56 ${showMenu ? "show" : ""}`} style={{
            width: 224,
            position: "absolute",
            inset: "0px auto auto 0px",
            margin: 0,
            transform: "translate(0px, 32px)"
         }}>
            <div className="dropdown-menu__content box bg-theme-26 dark:bg-dark-6 text-white">
               <div className="p-4 border-b border-theme-27 dark:border-dark-3">
                  <div className="font-medium">{auth && auth.userMeta && auth.userMeta.full_name}</div>
                  <div
                     className="text-xs text-theme-28 mt-0.5 dark:text-gray-600">{auth && auth.userMeta && auth.userMeta.user_name}
                  </div>
               </div>
               <div className="p-2">
                  <button type="button" onClick={() => setShowProfile(true)}
                     className="flex w-full items-center rounded-md p-2 text-right transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3">
                     <Icons.User className="w-4 h-4 ml-2"/> پروفایل </button>
                  <button type="button" onClick={resetPassword}
                     className="flex w-full items-center rounded-md p-2 text-right transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3">
                     <Icons.Lock className="w-4 h-4 ml-2"/> تغییر کلمه عبور </button>
                  <button type="button" onClick={changeSideBar}
                     className="flex w-full items-center rounded-md p-2 text-right transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3">
                     <Icons.ToggleLeft className="w-4 h-4 ml-2"/>{auth.sidebar ? 'منوی نواری' : 'منوی سایدبار'}</button>
                  <button type="button" onClick={() => toast.info('راهنمای پنل به‌زودی تکمیل می‌شود.')}
                     className="flex w-full items-center rounded-md p-2 text-right transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3">
                     <Icons.HelpCircle className="w-4 h-4 ml-2"/> راهنما </button>
               </div>
               <div className="p-2 border-t border-theme-27 dark:border-dark-3">
                  <button type="button" onClick={logout}
                     className="flex w-full items-center rounded-md p-2 text-right transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3">
                     <Icons.LogOut className="w-4 h-4 ml-2"/> خروج </button>
               </div>
            </div>
         </div>
      </div>
      <Modal show={showProfile} handleClose={() => setShowProfile(false)} title="اطلاعات کاربر">
         <div className="p-3 grid grid-cols-2">
            <div className="p-3 flex items-center justify-center">
               <img className="rounded-full h-48 w-48 object-cover"
                    src={(auth.userMeta && auth.userMeta.avatar) || "/images/account.jpg"} alt="تصویر کاربر"/>
            </div>
            <div>
               <p className="p-1"><span className="text-sm">نام : </span><span
                  className="text-theme-10">{auth.userMeta && auth.userMeta.first_name}</span></p>
               <p className="p-1"><span className="text-sm">نام خانوادگی : </span><span
                  className="text-theme-10">{auth.userMeta && auth.userMeta.last_name}</span></p>
               <p className="p-1"><span className="text-sm">نام کاربری : </span><span
                  className="text-theme-10">{auth.userMeta && auth.userMeta.user_name}</span></p>
               <p className="p-1"><span className="text-sm">تاریخ تولد : </span><span
                  className="text-theme-10">{auth.userMeta && auth.userMeta.birthday}</span></p>
               <p className="p-1"><span className="text-sm">کشور : </span><span
                  className="text-theme-10">{auth.userMeta && auth.userMeta.country && auth.userMeta.country.fa_name}</span>
               </p>
               <p className="p-1"><span className="text-sm">تاریخ ایجاد اکانت : </span><span
                  className="text-theme-10">{auth.userMeta && auth.userMeta.created_at}</span></p>
               <p className="p-1"><span className="text-sm">تاریخ تایید اکانت : </span><span
                  className="text-theme-10">{auth.userMeta && auth.userMeta.verified_at}</span></p>
               <p className="p-1"><span className="text-sm">آخرین بروز رسانی اکانت : </span><span
                  className="text-theme-10">{auth.userMeta && auth.userMeta.updated_at}</span></p>
            </div>
         </div>
      </Modal>
      <Modal show={showPassword} handleClose={() => setShowPassword(false)} title="تغییر گذرواژه">
         <Formik
            initialValues={{current_password: "", password: "", password_confirmation: ""}}
            validate={(values) => values.password !== values.password_confirmation
               ? {password_confirmation: "تکرار گذرواژه با گذرواژه یکسان نیست"}
               : {}}
            onSubmit={async (values, {setSubmitting}) => {
               try {
                  await axiosInstance.post('/auth/change-password', values);
                  toast.success('گذرواژه تغییر کرد؛ لطفاً دوباره وارد شوید.');
                  removeToken();
                  auth.dispatch({type: AUTH_REST});
                  setShowPassword(false);
                  navigate('/auth/login', {replace: true});
               } catch (error) {
                  handleErrors(error);
               } finally {
                  setSubmitting(false);
               }
            }}
         >
            {({dirty, isSubmitting}) => (
               <Form>
                  <div className="modal-body grid gap-3">
                     <Field component={TextField} label="گذرواژه فعلی" name="current_password" type="password"
                        validate={(value) => validationWrapper(value, required)}/>
                     <Field component={TextField} label="گذرواژه جدید" name="password" type="password"
                        validate={(value) => validationWrapper(value, required, minLength(8))}/>
                     <Field component={TextField} label="تکرار گذرواژه جدید" name="password_confirmation" type="password"
                        validate={(value) => validationWrapper(value, required, minLength(8))}/>
                  </div>
                  <div className="modal-footer text-right">
                     <button className="btn btn-primary w-24" disabled={!dirty || isSubmitting} type="submit">
                        {isSubmitting ? <Loading/> : 'تغییر گذرواژه'}
                     </button>
                     <button className="btn btn-outline-secondary mr-2 w-20" disabled={isSubmitting}
                        onClick={() => setShowPassword(false)} type="button">انصراف</button>
                  </div>
               </Form>
            )}
         </Formik>
      </Modal>
   </>);
}
